// Téléphone PROFESSIONNEL d'un compte (carnet de chantier) : seul numéro enregistré, jamais un numéro personnel.
// Texte saisi = hostile : longueur bornée AVANT toute expression régulière.

export const TELEPHONE_MAX = 40;

/**
 * Valide et met en forme un numéro saisi. Renvoie :
 *  - null si la saisie est vide (aucun numéro) ;
 *  - { erreur } si la saisie n'est pas un numéro de téléphone plausible ;
 *  - { valeur } sinon (espaces superflus retirés, caractères d'origine conservés pour l'affichage).
 */
export function lireTelephonePro(saisie: unknown): null | { valeur: string } | { erreur: string } {
  if (saisie === null || saisie === undefined) return null;
  if (typeof saisie !== 'string') return { erreur: 'Numéro de téléphone invalide.' };
  if (saisie.length > TELEPHONE_MAX * 2) return { erreur: `Numéro trop long (${TELEPHONE_MAX} caractères au plus).` };
  const v = saisie.trim().replace(/\s+/g, ' ');
  if (!v) return null;
  if (v.length > TELEPHONE_MAX) return { erreur: `Numéro trop long (${TELEPHONE_MAX} caractères au plus).` };
  if (!/^\+?[0-9 ().-]+$/.test(v)) return { erreur: 'Numéro invalide : chiffres, espaces, points, tirets, parenthèses et « + » initial seulement.' };
  const chiffres = v.replace(/\D/g, '').length;
  if (chiffres < 6 || chiffres > 15) return { erreur: 'Numéro invalide : entre 6 et 15 chiffres.' };
  return { valeur: v };
}

/** Lien d'appel `tel:` (chiffres et « + » initial seulement). */
export function lienTelephone(numero: string): string {
  const n = numero.trim();
  return `tel:${n.startsWith('+') ? '+' : ''}${n.replace(/\D/g, '')}`;
}
